import {createFileRoute} from '@tanstack/react-router';
import ClubDashboard from '../../../../clubs/dashboard/ClubDashboard';

// The new club dashboard (feature-flagged server-side via the new_dashboard AppSetting: while
// off, the endpoint 404s and this screen shows its quiet "not available" state).
export const Route = createFileRoute('/_app/clubs/$club_uid/dashboard')({
    component: () => {
        const {club_uid} = Route.useParams();
        return <ClubDashboard clubUid={club_uid} />;
    },
});
